import { SupportedLanguage, stringToLanguage } from '@estercare/ester-shared'
import { useTranslation } from 'react-i18next'

/**
 * Custom hook to get the current locale as a strictly typed SupportedLanguage value.
 * Uses ester-shared utilities for type-safe language handling.
 * Supports Swedish, English, and Norwegian.
 * Defaults to Swedish if the current language is not supported.
 *
 * @returns {SupportedLanguage} The current locale (sv, en, or nb)
 */
export const useLocale = (): SupportedLanguage => {
  const { i18n } = useTranslation()

  return stringToLanguage(i18n.language, SupportedLanguage.SWEDISH)
}
